import React from "react";
import styled from 'styled-components';
import {  variables, devices  } from "@d19n/ui-core";

const Section = styled.div`
    position: relative;
    margin: 0px auto;
    padding: 100px 15px;
    width: calc(100% - 180px );
    max-width: ${variables.maxWidth};

    &.p-0 {
        padding: 0px;
        width: 100%;
    }
    
    @media ${devices.tabletOnly} { 
        width: calc(100% - 160px );
        padding: 75px 15px;
    }
    
    @media ${devices.mobileOnly} { 
        width: calc(100% - 60px );
        padding: 75px 0;
    }

`;

const ContainerCol = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: start;
    flex-wrap: wrap;
    &.center { align-items: center; }
    &.reverse { flex-direction: column-reverse; }
    @media ${devices.tabletOnly} {
        &.reverse { flex-direction: column; }
    }
`;

const ContainerRow = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: start;
    flex-wrap: wrap;
    &.center { align-items: center; }
    &.reverse { flex-direction: row-reverse; }
    @media ${devices.tabletOnly} {
        &.reverse { flex-direction: row; }
    }
`;

const Item = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: stretch;
    flex-wrap: wrap;
`;

export const Container = ({ children, className = '' }) => {
    return (
        <Section className={className} >{children}</Section>
    )
}

export const Col = ({ children, className = '' }) => {
    return (
        <ContainerCol className={className} >{children}</ContainerCol>
    )
}

export const Row = ({ children, className = '' }) => {
    return (
        <ContainerRow className={className} >{children}</ContainerRow>
    )
}

export const FormItem = ({ children, className = '' }) => {
    return (
        <Item className={className} >{children}</Item>
    )
}